import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BottomHead = () => {
  const navigate = useNavigate();
  const headerItems = [
    {
      id: 1,
      name: "Home",
      key: "home",
      redirectionUrl: "/sports",
      // image: HomeICon,
      authRequired: false,
    },
    {
      id: 2,
      name: "In-Play",
      key: "In-play",
      redirectionUrl: "/sports/jetfair?section=In-play",
      // image: Inplay,
      authRequired: false,
    },
    {
      id: 3,
      name: "Cricket",
      key: "cricket",
      redirectionUrl: "/sports/jetfair?section=inplay",
      // image: Cricket,
      authRequired: false,
    },
    {
      id: 4,
      name: "Soccer",
      key: "Soccer",
      redirectionUrl: "/sports/jetfair?section=Soccer",
      // image: Soccer,
      authRequired: false,
    },
    {
      id: 5,
      name: "Tennis",
      key: "Tennis",
      redirectionUrl: "/sports/jetfair?section=Tennis",
      // image: Tennis,
      authRequired: false,
    },
    {
      id: 6,
      name: "Casino",
      key: "casino",
      redirectionUrl: "/allCasino",
      // image: Horse,
      authRequired: false,
    },
    {
      id: 7,
      name: "Horse Racing",
      key: "horse",
      redirectionUrl: "/sports/jetfair?section=Horse%20Racing",
      // image: Horse,
      authRequired: false,
    },
    // {
    //   id: 8,
    //   name: "Greyhound Racing",
    //   key: "greyhound",
    //   redirectionUrl: "/sports/jetfair?section=inplay",
    //   // image: Greyhound,
    //   authRequired: false,
    // },
    // {
    //   id: 9,
    //   name: "Exchange",
    //   key: "ipl",
    //   redirectionUrl: "/sports/jetfair?section=inplay",
    //   // image: EvolutionImg,
    //   authRequired: false,
    // },
    // {
    //   id: 10,
    //   name: "Politics",
    //   key: "politics",
    //   redirectionUrl: "/sportsbook/Politics",
    //   // image: AvitorImg,
    //   authRequired: false,
    // },
    // {
    //   id: 11,
    //   name: "Int Casino",
    //   key: "intcasino",
    //   redirectionUrl: "/allCasino",
    //   // image: LCImg,
    //   authRequired: false,
    // },
    // {
    //   id: 12,
    //   name: "Sports Book",
    //   key: "sportsbook",
    //   redirectionUrl: "/betby",
    //   // image: EvolutionImg,
    //   authRequired: false,
    // },
    // {
    //   id: 11,
    //   name: "Qtech",
    //   key: "qtech",
    //   redirectionUrl: "/qtechlobby",
    //   // image: QtechImg1,
    //   authRequired: true,
    // },
    // {
    //   id: 12,
    //   name: "Supernowa",
    //   key: "supernowa",
    //   redirectionUrl: "/casino/supernowa",
    //   // image: SupernowaImg,
    //   authRequired: true,
    // },
    // {
    //   id: 13,
    //   name: "World Casino",
    //   key: "worldCasino",
    //   redirectionUrl: "/casino/worldcasino",
    //   // image: WCImg,
    //   authRequired: true,
    // },
    // {
    //   id: 14,
    //   name: "Slots",
    //   key: "slots",
    //   redirectionUrl: "/Slots",
    //   // image: SlotsImg,
    //   authRequired: true,
    // },
    // {
    //   id: 15,
    //   name: "Ezugi",
    //   key: "ezugi",
    //   redirectionUrl: "/casino/ezugi",
    //   // image: EzugiImg,
    //   authRequired: true,
    // },
  ];
  const location = useLocation();

  const checkIfActive = (key) => {
    return key === location?.state?.activePage;
  };

  return (
    <div className="Bottom_head">
      <ul>
        {Array.isArray(headerItems) &&
          headerItems.map((item, index) => {
            return (
              <li className="" key={index}>
                <div
                  onClick={() => {
                    if (item?.authRequired === false) {
                      navigate(item.redirectionUrl, {
                        state: {
                          activePage: item?.key,
                        },
                      });
                    } else {
                      window.location.href = "/sign-in";
                    }
                  }}
                  className={checkIfActive(item?.key) ? "active" : ""}
                >
                  {item?.name}
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default BottomHead;
